import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import RequireAuth from 'components/RequireAuth';
import RequireRole from 'components/RequireRole';
import DashboardLayout from 'layout/Dashboard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - 감정 관리 (도메인)
const ExpectedFeesPage = Loadable(lazy(() => import('pages/expected-fees')));
const ExpectedFeeDetailPage = Loadable(lazy(() => import('pages/expected-fees/detail')));
const ContentsPage = Loadable(lazy(() => import('pages/contents')));
const ContentsDetailPage = Loadable(lazy(() => import('pages/contents/detail')));
const AdminUsersPage = Loadable(lazy(() => import('pages/admin/users')));
const AdminMasterPage = Loadable(lazy(() => import('pages/admin/master')));
const AdminStoragePage = Loadable(lazy(() => import('pages/admin/storage')));

// render - 캘린더
const CalendarPage = Loadable(lazy(() => import('pages/calendar')));

// render - spike (검증용, 메뉴 비노출, URL 직접 접근)
const SpikeSubArrayPage = Loadable(lazy(() => import('pages/spike/sub-array-editor')));
const SpikeCalendarPocPage = Loadable(lazy(() => import('pages/spike/calendar-poc')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <RequireAuth>
      <DashboardLayout />
    </RequireAuth>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      // 감정 관리 (도메인)
      path: 'expected-fees',
      children: [
        { index: true, element: <ExpectedFeesPage /> },
        { path: 'new', element: <ExpectedFeeDetailPage /> },
        { path: ':id', element: <ExpectedFeeDetailPage /> }
      ]
    },
    {
      path: 'contents',
      children: [
        { index: true, element: <ContentsPage /> },
        { path: ':id', element: <ContentsDetailPage /> }
      ]
    },
    {
      path: 'admin',
      children: [
        {
          path: 'users',
          element: (
            <RequireRole role="admin">
              <AdminUsersPage />
            </RequireRole>
          )
        },
        {
          path: 'master',
          element: (
            <RequireRole role="admin">
              <AdminMasterPage />
            </RequireRole>
          )
        },
        {
          path: 'storage',
          element: (
            <RequireRole role="admin">
              <AdminStoragePage />
            </RequireRole>
          )
        }
      ]
    },
    {
      path: 'calendar',
      element: <CalendarPage />
    },
    {
      // spike — 검증용. 메뉴 비노출, URL 직접 접근만. 검증 후 삭제 예정.
      path: 'spike',
      children: [
        { path: 'sub-array-editor', element: <SpikeSubArrayPage /> },
        { path: 'calendar-poc', element: <SpikeCalendarPocPage /> }
      ]
    }
  ]
};

export default MainRoutes;
